import { render } from "./SideBarView.vue?vue&type=template&id=49b2e49e&scoped=true"
import script from "./SideBarView.vue?vue&type=script&lang=js"
export * from "./SideBarView.vue?vue&type=script&lang=js"

import "./SideBarView.vue?vue&type=style&index=0&id=49b2e49e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b2e49e"]])

export default __exports__